export const HEADER_HEIGHT = 64;

// Site device tree view
export const TREE_HEADER_HEIGHT = 36;

export const SPACER_MINI = 8;

// Component Tabs
export const TABS_HEIGHT = 32; //48

// Sites panel constants
export const PANEL_HEADER = 32;

// Sentinel timestamp meaning "no end / still active"
export const FOREVER_TIMESTAMP = 4102444800;
